module.exports = __webpack_public_path__ + "img/Green_Space_Invader.0b95b2f5.gif";